import { Link } from 'react-router';
import styled from 'styled-components';

import hhLogo from '../../assets/hscan-landing/healthhub.png';

export const LayoutBackground = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fd;

  ${p =>
    p.theme.isMobile &&
    `
    background-color: #f5f5f5;
    `}
`;

export const LayoutHeaderContainer = styled.header<{ $height: string }>`
  position: relative;
  width: 100%;
  height: ${p => p.$height};
  background-color: ${p => '#00025a' || p.theme.colors.primary};
`;

export const LayoutHeaderContent = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 22px 20px 28px;
  margin: 0 auto; /* center */
  max-width: ${'1120px'};
  height: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  column-gap: 12px;
  color: ${p => p.theme.colors.white};
`;

export const LayoutHeaderContentLeft = styled.div``;

export const LayoutHeaderContentRight = styled.div<{ $gap?: string }>`
  display: flex;
  align-items: center;
  gap: ${p => p.$gap ?? 'unset'};
`;

export const LayoutHeaderLink = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${p => p.theme.colors.white};
  cursor: pointer;
  word-break: keep-all;
`;

export const UserInfo = styled.span`
  font-size: 16px;
  color: ${p => p.theme.colors.white};
`;

export const LayoutHeaderButton = styled.button`
  margin: 0;
  width: 100px;
  height: 40px;
  box-sizing: border-box;
  padding: 4px;
  border: none;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  background-color: ${p => '#2e5be0' || p.theme.colors.textColorInPrimary};
  color: ${p => p.theme.colors.white};
  cursor: pointer;
`;

export const LayoutFooter = styled.footer``;

export const LayoutFooterAside = styled.aside`
  background: #010259;
  color: #ffffff;
  padding: 0 27px;
`;

export const LayoutFooterMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 30px;
  padding-bottom: 10px;

  ${p =>
    p.theme.isMobile &&
    `
    padding-top: 24px;
    padding-bottom: 24px;
    `}
`;
export const LayoutFooterFamilySiteSection = styled.section`
  flex: 1;
  width: 100%;
`;
export const LayoutFooterMenuSection = styled.section<{ $maxWidth?: number }>`
  flex: 1;
  ${p => (p.$maxWidth !== undefined ? `max-width: ${p.$maxWidth}px` : '')}
  ${p => p.theme.isMobile && 'display: flex; justify-content: center;'}
`;
export const LayoutFooterMenuSection2 = styled.section`
  flex: 1;
  display: contents;

  ${p =>
    p.theme.isMobile &&
    `
    display: block;
    `}
`;
export const LayoutFooterMenuSection3 = styled.section`
  flex: 1;
`;
export const LayoutFooterMenuHeading = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding-top: 8px;

  ${p => p.theme.isMobile && 'text-align: center;'}
`;
export const LayoutFooterContactList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
  gap: 40px;

  ${p =>
    p.theme.isMobile &&
    `
    flex-direction: column;
    gap: 15px;
    font-size: 12px;
    `}
}
`;
export const LayoutFooterMenuContent = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
  gap: 40px;

  ${p =>
    p.theme.isMobile &&
    `
    font-size: 12px;
    gap: 20px;
    justify-content: center;
    `}
`;
export const LayoutFooterFamilySiteContent = styled(LayoutFooterMenuContent)`
  @media (max-width: 1129px) {
    flex-wrap: wrap;
  }
`;
export const LayoutFooterContactItem = styled.li`
  position: relative;
  margin: 0;
  padding: 8px 0;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -20px;
    display: block;
    width: 1px;
    height: 12px;
    background-color: #ffffff;
    transform: translateY(-50%);
  }
  &:first-child::before {
    display: none;
  }

  @media (max-width: 1129px) {
    &::before {
      display: none;
    }
  }
`;

export const LayoutFooterMenuContentItem = styled.li`
  position: relative;
  margin: 0;
  padding: 8px 0;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -20px;
    display: block;
    width: 1px;
    height: 12px;
    background-color: #ffffff;
    transform: translateY(-50%);
  }
  &:first-child::before {
    display: none;
  }

  ${p =>
    p.theme.isMobile &&
    `
    &::before {
      display: none;
    }
  `}
`;
export const LayoutFooterFamilySiteItem = styled.li`
  position: relative;
  margin: 0;
  padding: 8px 0;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -20px;
    display: block;
    width: 1px;
    height: 12px;
    background-color: #ffffff;
    transform: translateY(-50%);
  }
  &:first-child::before {
    display: none;
  }

  ${p =>
    p.theme.isMobile &&
    `
    padding-bottom: 0;

    &::before {
      display: none;
    }
  `}
`;
export const LayoutFooterCompanyContentList = styled.ul`
  display: flex;
  list-style: none;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  font-size: 14px;
  gap: 20px;

  @media (max-width: 1129px) {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  @media (max-width: 649px) {
    display: block;
    flex-direction: column;
    flex-wrap: unset;
    text-align: center;
  }
`;
export const LayoutFooterCompanyContentItem = styled.li`
  margin: 0;
  list-style: none;
  font-size: 14px;
  white-space: nowrap;

  @media (max-width: 649px) {
    white-space: normal;
    margin-top: 12px;

    &:first-child {
      margin-top: 0;
    }
  }
`;
export const LayoutFooterMenuLink = styled.a`
  color: #ffffff;
  text-decoration: none;
`;
export const LayoutFooterMenuInternalLink = styled(Link)`
  color: #ffffff;
  text-decoration: none;
`;
export const LayoutFooterPrivacyPolicyLink = styled(
  LayoutFooterMenuInternalLink,
)`
  font-weight: 700;
  @media (max-width: 1129px) {
    font-weight: 400;
  }
`;

export const LayoutFooterMenuSnsIcons = styled.div`
  display: flex;
  justify-content: end;
  gap: 28px;
  line-height: 0;
  width: 100%;

  @media (max-width: 1129px) {
    justify-content: start;
  }
  @media (max-width: 649px) {
    gap: 16px;
    justify-content: center;
  }
`;
export const SnsLink = styled.a`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0.05) 60%,
    transparent 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SnsIcon = styled.img`
  width: 20px;
  height: 20px;
  color: transparent;
  font-size: 0;
  padding: 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: radial-gradient(
      circle at 30% 30%,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0.05) 60%,
      transparent 100%
    );
    z-index: 0;
  }
`;

export const SnSWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1129px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    margin-top: 20px;
    gap: 20px;
  }
`;

export const LayoutFooterContact = styled.address`
  height: 64px;
  font-size: 12px;
  line-height: 1;
  font-style: normal;
  background: #0051ff;
  color: white;
  padding: 0px 27px;

  // shrink 일 때 글자 크기 줄임
  @media (max-width: 1129px) {
    display: none;
  }

  // mobile일 때 다시 보여줌
  @media (max-width: 649px) {
    display: block;
    font-size: 8px;
    height: 222px;
  }
`;

export const LayoutFooterContactContent = styled.div`
  margin: 0 auto; /* center */
  max-width: calc(1130px - 27px * 2);

  ${LayoutFooterContact} & {
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    word-break: keep-all;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 4px;
  }
`;
export const LayoutFooterAsideContent = styled.div`
  margin: 0 auto; /* center */
  max-width: calc(1130px - 27px * 2);
  box-sizing: border-box;

  ${LayoutFooterContact} & {
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
    word-break: keep-all;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 4px;
  }
`;

export const LayoutFooterMobileAddressTitle = styled.div`
  font-weight: bold;
  text-align: center;
`;

export const LayoutFooterHealthhubLogo = styled.div`
  width: 206px;
  height: 37px;
  margin-top: 53px;
  background-image: url(${hhLogo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export const AlertNoti = styled.span`
  position: absolute;
  right: 2px;
  top: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #21d899;
  z-index: 1;
`;
